import { forwardRef } from "react";

const NativeSelect = forwardRef(function NativeSelect(
  { error = false, size, className = "", children, ...rest },
  ref
) {
  const classes = [
    "peb-native-select",
    size === "sm" ? "peb-native-select--sm" : "",
    error ? "peb-input--error" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <select ref={ref} className={classes} {...rest}>
      {children}
    </select>
  );
});

export default NativeSelect;
